import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import mobile from '../../assets/images/mobile-development.webp';
import software from '../../assets/images/code.webp'
import website from '../../assets/images/app-development.webp'
import ecommerce from '../../assets/images/web.webp'
import digital from '../../assets/images/social-media.webp'
import branding from '../../assets/images/digital-marketing.webp'
import threeDAni from '../../assets/images/3d.webp'
import educon from '../../assets/images/educational-consultancy1.webp'
import client1 from '../../assets/images/client23.webp'
import client2 from '../../assets/images/client22.webp'
import client3 from '../../assets/images/client20.webp'
import client4 from '../../assets/images/client21.webp'
import client5 from '../../assets/images/client3.webp'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SpaceBackground from '../../components/SpaceBackground';
const Home = () => {
  const servicesTrackRef = useRef(null);
  const industriesTrackRef = useRef(null);
  const svgRef = useRef(null);
  const containerRef = useRef(null);
  const cardRefs = useRef([]);
  const itemsRef = useRef([]);
  const [active, setActive] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

 const [isMobile, setIsMobile] = useState(false);
 useEffect(() => {
   const checkMobile = () => {
     setIsMobile(window.innerWidth <= 768);
   };
   
   checkMobile();
   window.addEventListener('resize', checkMobile);
   
   return () => window.removeEventListener('resize', checkMobile);
 }, []);

  useEffect(() => {
    // Mobile menu functionality
    const hamburger = document.getElementById('hamburger');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileClose = document.getElementById('mobileClose');
    const overlay = document.getElementById('overlay');
    const toggles = document.querySelectorAll('.mobile-toggle');

    const openMenu = () => {
      mobileMenu?.classList.add('open');
      overlay?.classList.add('open');
    };

    const closeMenu = () => {
      mobileMenu?.classList.remove('open');
      overlay?.classList.remove('open');
    };

    hamburger?.addEventListener('click', openMenu);
    mobileClose?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);

    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const sibling = toggle.nextElementSibling;
        if (sibling) sibling.classList.toggle('open');
      });
    });

    // Services carousel
    const servicesTrack = servicesTrackRef.current;
    if (servicesTrack) {
      const servicesContainer = servicesTrack.parentElement;
      const originalCards = Array.from(servicesTrack.children);
      const originalLength = originalCards.length;
      const getCardWidth = () => {
        if (window.innerWidth <= 600) return window.innerWidth - 40; // Full width minus padding
        return Math.min(300, window.innerWidth * 0.9); // Max 300px or 90% of screen
      };
      const cardWidth = getCardWidth();
      const gap = parseFloat(getComputedStyle(servicesTrack).gap) || 30;
      const slideWidth = cardWidth + gap;
      const containerWidth = servicesContainer.getBoundingClientRect().width;
      const numVisible = Math.floor(containerWidth / slideWidth);
      const numClones = numVisible + 1;

      // Prepend clones of last numClones cards
      for (let i = originalLength - numClones; i < originalLength; i++) {
        servicesTrack.prepend(originalCards[i].cloneNode(true));
      }

      // Append clones of first numClones cards
      for (let i = 0; i < numClones; i++) {
        servicesTrack.appendChild(originalCards[i].cloneNode(true));
      }

      let currentServiceIndex = numClones;
      servicesTrack.style.transform = `translateX(-${currentServiceIndex * slideWidth}px)`;

      const servicesNextBtn = document.querySelector('.home-services-section .home-nextBtn');
      const servicesPrevBtn = document.querySelector('.home-services-section .home-prevBtn');
      const servicesDotsNav = document.querySelector('.home-services-section .home-carousel-dots');
      const servicesDots = servicesDotsNav ? Array.from(servicesDotsNav.children) : [];

      const moveToServiceSlide = (index, animate = true) => {
        servicesTrack.style.transition = animate ? 'transform 0.5s ease-in-out' : 'none';
        servicesTrack.style.transform = `translateX(-${index * slideWidth}px)`;
        currentServiceIndex = index;

        let effectiveIndex = (currentServiceIndex - numClones) % originalLength;
        if (effectiveIndex < 0) effectiveIndex += originalLength;
        servicesDots.forEach(dot => dot.classList.remove('home-active'));
        if (servicesDots[effectiveIndex]) {
          servicesDots[effectiveIndex].classList.add('home-active');
        }
      };

      const moveToNextServiceSlide = () => {
        currentServiceIndex++;
        moveToServiceSlide(currentServiceIndex);
      };

      const moveToPrevServiceSlide = () => {
        currentServiceIndex--;
        moveToServiceSlide(currentServiceIndex);
      };

      servicesTrack.addEventListener('transitionend', () => {
        if (currentServiceIndex >= numClones + originalLength) {
          servicesTrack.style.transition = 'none';
          currentServiceIndex -= originalLength;
          moveToServiceSlide(currentServiceIndex, false);
        } else if (currentServiceIndex < numClones) {
          servicesTrack.style.transition = 'none';
          currentServiceIndex += originalLength;
          moveToServiceSlide(currentServiceIndex, false);
        }
      });

      servicesNextBtn?.addEventListener('click', moveToNextServiceSlide);
      servicesPrevBtn?.addEventListener('click', moveToPrevServiceSlide);

      servicesDots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          currentServiceIndex = numClones + idx;
          moveToServiceSlide(currentServiceIndex);
        });
      });

      // Auto-play
      let servicesAutoPlay = setInterval(moveToNextServiceSlide, 3000);
      const servicesCarousel = document.querySelector('.home-services-section .home-carousel');

      servicesCarousel?.addEventListener('mouseenter', () => clearInterval(servicesAutoPlay));
      servicesCarousel?.addEventListener('mouseleave', () => {
        servicesAutoPlay = setInterval(moveToNextServiceSlide, 3000);
      });

      // Update card sizes on resize
      window.addEventListener('resize', () => {
        const newCardWidth = getCardWidth();
        const newSlideWidth = newCardWidth + gap;
        servicesTrack.style.transition = 'none';
        servicesTrack.style.transform = `translateX(-${currentServiceIndex * newSlideWidth}px)`;
        servicesTrack.querySelectorAll('.home-card').forEach(card => {
          card.style.width = `${newCardWidth}px`;
        });
      });
    }

    // Industries carousel
    const industriesTrack = industriesTrackRef.current;
    if (industriesTrack) {
      const industriesContainer = industriesTrack.parentElement;
      const originalCards = Array.from(industriesTrack.children);
      const originalLength = originalCards.length;
      const getCardWidth = () => {
        if (window.innerWidth <= 600) return window.innerWidth - 30; // Full width minus padding
        return Math.min(300, window.innerWidth * 0.9); // Max 300px or 90% of screen
      };
      const cardWidth = getCardWidth();
      const gap = parseFloat(getComputedStyle(industriesTrack).gap) || 20;
      const slideWidth = cardWidth + gap;
      const containerWidth = industriesContainer.getBoundingClientRect().width;
      const numVisible = Math.floor(containerWidth / slideWidth);
      const numClones = numVisible + 1;

      // Prepend clones of last numClones cards
      for (let i = originalLength - numClones; i < originalLength; i++) {
        industriesTrack.prepend(originalCards[i].cloneNode(true));
      }

      // Append clones of first numClones cards
      for (let i = 0; i < numClones; i++) {
        industriesTrack.appendChild(originalCards[i].cloneNode(true));
      }

      let currentIndustryIndex = numClones;
      industriesTrack.style.transform = `translateX(-${currentIndustryIndex * slideWidth}px)`;

      const industriesNextBtn = document.querySelector('.home-industries-section .home-industry-nav-button#home-nextBtn');
      const industriesPrevBtn = document.querySelector('.home-industries-section .home-industry-nav-button#home-prevBtn');
      const industriesDotsNav = document.querySelector('.home-industries-dots');
      const industriesDots = industriesDotsNav ? Array.from(industriesDotsNav.children) : [];

      const moveToIndustrySlide = (index, animate = true) => {
        industriesTrack.style.transition = animate ? 'transform 0.5s ease-in-out' : 'none';
        industriesTrack.style.transform = `translateX(-${index * slideWidth}px)`;
        currentIndustryIndex = index;

        let effectiveIndex = (currentIndustryIndex - numClones) % originalLength;
        if (effectiveIndex < 0) effectiveIndex += originalLength;
        industriesDots.forEach(dot => dot.classList.remove('home-active'));
        if (industriesDots[effectiveIndex]) {
          industriesDots[effectiveIndex].classList.add('home-active');
        }
      };

      const moveToNextIndustrySlide = () => {
        currentIndustryIndex++;
        moveToIndustrySlide(currentIndustryIndex);
      };

      const moveToPrevIndustrySlide = () => {
        currentIndustryIndex--;
        moveToIndustrySlide(currentIndustryIndex);
      };

      industriesTrack.addEventListener('transitionend', () => {
        if (currentIndustryIndex >= numClones + originalLength) {
          industriesTrack.style.transition = 'none';
          currentIndustryIndex -= originalLength;
          moveToIndustrySlide(currentIndustryIndex, false);
        } else if (currentIndustryIndex < numClones) {
          industriesTrack.style.transition = 'none';
          currentIndustryIndex += originalLength;
          moveToIndustrySlide(currentIndustryIndex, false);
        }
      });

      industriesNextBtn?.addEventListener('click', moveToNextIndustrySlide);
      industriesPrevBtn?.addEventListener('click', moveToPrevIndustrySlide);

      industriesDots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          currentIndustryIndex = numClones + idx;
          moveToIndustrySlide(currentIndustryIndex);
        });
      });

      // Auto-play
      let industriesAutoPlay = setInterval(moveToNextIndustrySlide, 3000);
      const industriesCarousel = document.querySelector('.home-industries-carousel');

      industriesCarousel?.addEventListener('mouseenter', () => clearInterval(industriesAutoPlay));
      industriesCarousel?.addEventListener('mouseleave', () => {
        industriesAutoPlay = setInterval(moveToNextIndustrySlide, 3000);
      });

      // Update card sizes on resize
      window.addEventListener('resize', () => {
        const newCardWidth = getCardWidth();
        const newSlideWidth = newCardWidth + gap;
        industriesTrack.style.transition = 'none';
        industriesTrack.style.transform = `translateX(-${currentIndustryIndex * newSlideWidth}px)`;
        industriesTrack.querySelectorAll('.home-industry-card').forEach(card => {
          card.style.width = `${newCardWidth}px`;
        });
      });
    }
    // Cleanup
    return () => {
      hamburger?.removeEventListener('click', openMenu);
      mobileClose?.removeEventListener('click', closeMenu);
      overlay?.removeEventListener('click', closeMenu);
      toggles.forEach(toggle => {
        toggle.removeEventListener('click', () => {
          const sibling = toggle.nextElementSibling;
          if (sibling) sibling.classList.toggle('open');
        });
      });
    };
  }, []);

  // Process section logic
  useEffect(() => {
    cardRefs.current = cardRefs.current.slice(0, 5);
  }, []);

  const connectCards = () => {
    if (!containerRef.current || !svgRef.current) return;

    const cards = cardRefs.current.filter(Boolean);
    if (cards.length !== 5) return;

    const cardRects = cards.map(card => card.getBoundingClientRect());
    const containerRect = containerRef.current.getBoundingClientRect();
    
    // Clear previous lines and pulses
    const existingLines = svgRef.current.querySelectorAll('.home-dynamic-line, .home-energy-pulse');
    existingLines.forEach(el => el.remove());
    
    const getRelativePos = (card) => {
      return {
        x: card.left - containerRect.left + card.width / 2,
        y: card.top - containerRect.top + card.height / 2
      };
    };
    
    const positions = cardRects.map(card => getRelativePos(card));
    
    // Define connections based on your original pattern
    const connections = [
      { from: positions[0], to: positions[3], id: 'line1' }, // card1 to card2
      { from: positions[0], to: positions[2], id: 'line2' }, // card1 to card3
      { from: positions[0], to: positions[1], id: 'line3' }, // card1 to card4
      { from: positions[2], to: positions[4], id: 'line4' }  // card3 to card5
    ];
    
    // Draw lines and create energy pulses
    connections.forEach(conn => {
      // Draw line
      const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
      line.setAttribute('x1', conn.from.x);
      line.setAttribute('y1', conn.from.y);
      line.setAttribute('x2', conn.to.x);
      line.setAttribute('y2', conn.to.y);
      line.setAttribute('class', 'home-dynamic-line');
      line.style.stroke = 'cyan';
      line.style.strokeWidth = '3';
      line.style.strokeLinecap = 'round';
      line.style.filter = 'drop-shadow(0 0 6px cyan) drop-shadow(0 0 12px cyan)';
      line.style.strokeDasharray = '1000';
      line.style.strokeDashoffset = '1000';
      line.style.animation = 'flow 2s linear infinite';
      svgRef.current.appendChild(line);
      
      // Create energy pulse
      const pulse = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      pulse.setAttribute('class', 'home-energy-pulse');
      pulse.setAttribute('r', '5');
      pulse.setAttribute('fill', 'cyan');
      pulse.setAttribute('filter', 'url(#glow)');
      
      // Animate the pulse along the line
      const animate = document.createElementNS("http://www.w3.org/2000/svg", "animateMotion");
      animate.setAttribute('dur', '2s');
      animate.setAttribute('repeatCount', 'indefinite');
      animate.setAttribute('path', `M ${conn.from.x} ${conn.from.y} L ${conn.to.x} ${conn.to.y}`);
      animate.setAttribute('keyPoints', '0;1');
      animate.setAttribute('keyTimes', '0;1');
      animate.setAttribute('calcMode', 'linear');
      
      pulse.appendChild(animate);
      svgRef.current.appendChild(pulse);
    });
  };

  useEffect(() => {
    // Add animation to cards
    cardRefs.current.forEach((card, index) => {
      if (card) {
        card.style.animation = `fadeUp 0.8s ease-out ${index * 0.2}s both`;
      }
    });

    // Initial call after a small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      connectCards();
    }, 100);

    // Redraw on window resize with debounce
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(connectCards, 250);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const processSteps = [
    {
      id: "card1",
      image: "/images/consultation.webp",
      title: "Initial Consultation",
      description: "We start with a detailed consultation to understand your needs, goals, and challenges."
    },
    {
      id: "card2",
      image: "/images/proposal.webp",
      title: "Project Proposal",
      description: "We provide a detailed proposal outlining the scope, timeline, and cost of the project."
    },
    {
      id: "card3",
      image: "/images/development.webp",
      title: "Development & Testing",
      description: "Our team begins development according to the approved proposal, with thorough testing."
    },
    {
      id: "card4",
      image: "/images/feedback.webp",
      title: "Feedback & Iteration",
      description: "We gather your feedback and make necessary adjustments to meet your expectations."
    },
    {
      id: "card5",
      image: "/images/deployment.webp",
      title: "Deployment & Support",
      description: "We deploy the final product and provide ongoing support to ensure everything runs smoothly."
    }
  ];

  const orderedSteps = [
    processSteps[0], // card1 - top center
    processSteps[3], // card4 - right middle
    processSteps[2], // card3 - center middle
    processSteps[1], // card2 - left middle
    processSteps[4]  // card5 - bottom center
  ];

 const originalSlides = [
    { 
      title: "HEALTH CARE", 
      text: "Transforming Health with Technology. We leverage technology to enhance patient care, streamline operations, and support better outcomes."
    },
    { 
      title: "EDUCATION", 
      text: "Empowering Learning with Innovation. Our solutions drive educational excellence by offering interactive, scalable, and accessible technology." 
    },
    { 
      title: "TRANSPORT", 
      text: "Streamlining Mobility with Tech. We provide advanced solutions for transportation, logistics, and user experiences in mobility." 
    },
    { 
      title: "FINANCE", 
      text: "Empowering Financial Services with Tech. We help financial institutions with automation, security, and smarter customer engagement." 
    },
    { 
      title: "MARKETING", 
      text: "Driving Growth with Market Insights. We optimize strategies, analyze consumer behavior, and enhance business decision-making processes." 
    },
    { 
      title: "FOOD", 
      text: "Innovative Solutions for Food. We improve food operations, supply chains, and efficiency with smart technology solutions." 
    }
  ];


  const originalLength = originalSlides.length;
  const numClones = 2;
  const fullSlides = [...originalSlides.slice(-numClones), ...originalSlides, ...originalSlides.slice(0, numClones)];


 const loadShow = () => {
    const items = itemsRef.current;
    let stt = 0;

    if (!items || items.length === 0) return;

    // Reset all items first
    items.forEach(item => {
      if (item) {
        item.style.transform = "none";
        item.style.zIndex = "0";
        item.style.filter = "none";
        item.style.opacity = "0.6";
      }
    });

    // Active item
    if (items[active]) {
      items[active].style.transform = "none";
      items[active].style.zIndex = "1";
      items[active].style.filter = "none";
      items[active].style.opacity = "1";
    }

    // Items to the right
    for (let i = active + 1; i < items.length; i++) {
      stt++;
      if (!items[i]) continue;
      items[i].style.transform = `translateX(${120 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(-1deg)`;
      items[i].style.zIndex = -stt;
      items[i].style.filter = "blur(5px)";
      items[i].style.opacity = stt > 2 ? "0" : "0.6";
    }

    // Items to the left
    stt = 0;
    for (let i = active - 1; i >= 0; i--) {
      stt++;
      if (!items[i]) continue;
      items[i].style.transform = `translateX(${-120 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(1deg)`;
      items[i].style.zIndex = -stt;
      items[i].style.filter = "blur(5px)";
      items[i].style.opacity = stt > 2 ? "0" : "0.6";
    }
  };

const checkAndReset = () => {
    let newActive = active;
    let needsReset = false;

    if (active >= numClones + originalLength) {
      newActive = active - originalLength;
      needsReset = true;
    } else if (active < numClones) {
      newActive = active + originalLength;
      needsReset = true;
    }

    if (needsReset) {
      // Disable transitions for reset
      itemsRef.current.forEach((item) => {
        if (item) item.style.transition = 'none';
      });
      
      setActive(newActive);
      
      // Re-enable transitions after reset
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          itemsRef.current.forEach((item) => {
            if (item) item.style.transition = 'all 0.5s ease';
          });
        });
      });
    }
  };

  const nextSlide = () => {
    setActive((prev) => prev + 1);
  };

  const prevSlide = () => {
    setActive((prev) => prev - 1);
  };

  useEffect(() => {
    loadShow();
    // Add checkAndReset call here - this was missing
    const resetTimer = setTimeout(checkAndReset, 500);
    return () => clearTimeout(resetTimer);
  }, [active]);

  useEffect(() => {
    let interval;
    if (autoPlay) {
      interval = setInterval(nextSlide, 3000);
    }
    return () => clearInterval(interval);
  }, [autoPlay, nextSlide]); // Added nextSlide to dependencies

  useEffect(() => {
    setActive(numClones);
  }, []);

  // Add mouse enter/leave handlers for autoplay
  useEffect(() => {
    const handleMouseEnter = () => setAutoPlay(false);
    const handleMouseLeave = () => setAutoPlay(true);

    const slider = document.querySelector('.home-why-choose-slider');
    if (slider) {
      slider.addEventListener('mouseenter', handleMouseEnter);
      slider.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      if (slider) {
        slider.removeEventListener('mouseenter', handleMouseEnter);
        slider.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, []);
 
  return (
    <div className="home" id="home-oakya">
      {/* Hero Section */}
      <section className="home-hero" id="home-hero">
  <div className="home-hero-bg"></div>
  <div className="home-stars">
    <img src="/images/stars4.webp" className="home-hero-stars-1" alt="Stars" />
    <img src="/images/stars5.webp" className="home-hero-stars-2" alt="Stars" />
    <img src="/images/stars6.webp" className="home-hero-stars-3" alt="Stars" />
  </div>
  <div className="home-rocks">
    <img src="/images/rock3.webp" className="home-hero-rocks home-rock-small home-rock-s1" alt="Small Rock" />
    <img src="/images/rock3.webp" className="home-hero-rocks home-rock-small home-rock-s2" alt="Small Rock" />
    <img src="/images/rock3.webp" className="home-hero-rocks home-rock-small home-rock-s3" alt="Small Rock" />
    <img src="/images/rock1.webp" className="home-hero-rocks home-rock-back" alt="Rocks Back" />
    <img src="/images/rock2.webp" className="home-hero-rocks home-rock-front" alt="Rocks Front" />
  </div>
  <div className="home-astronaut">
    <img src="/images/hero-astronaut.webp" alt="Astronaut" className="home-hero-astronaut" />
  </div>
  <div className="home-hero-overlay">
    <h1>OAKYA IT SERVICES</h1>
  </div>
</section>

      {/* About Section */}
      <section id="home-about" className="home-about">
        <div className="home-about-left">
          <div className="home-about-text">
            <h2>About</h2>
            <p>Our Company</p>
          </div>
        </div>
        <div className="home-about-right">
          <h2>Fortify Your Business with Oakya</h2>
          <p>
            Tired of tech headaches slowing you down? We get it. You didn't start your business to manage servers and fight off cyber threats. You started it to innovate, serve customers, and grow. <br />
            That's where we come in. Oakya is your partner in building a technology foundation that's secure, efficient, and powerful. We handle the complex IT, so you can get back to what you do best.
          </p>
          <div className="home-services">
            <div className="home-service-card">
              <h3>Customer Service</h3>
              <div className="home-service-underline"></div>
              <img src="/images/customer-service.webp" alt="Customer Service" />
            </div>
            <div className="home-service-card">
              <h3>Technical Support</h3>
              <div className="home-service-underline"></div>
              <img src="/images/technical-support.webp" alt="Technical Support" />
            </div>
          </div>
          <div className="home-contact-bar">
            <span className="home-contact-us">
              <a href="tel:+919134747474">
                <img src="/images/contact-btn.webp" alt="Contact Button" />
              </a>
            </span>
            <span className="home-phone">
              <img src="/images/call-icon.webp" alt="Call Icon" />
              <a href="tel:+919134747474">+91 9134747474</a>
            </span>
            
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="home-services-section" id="home-services-section">
        <h2 className="home-section-title">Our Awesome Services</h2>
        <div className="home-section-underline"></div>
        
        <div className="home-services-container">
          <ul className="home-services-cards">
            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={software} alt="Software Development" width="120" />
                </div>
                <h2 className="home-service-card-title">Software <br/> Development</h2>
              </div>
              <div className="home-service-card-content">
                <p>Build proprietary systems for operational superiority.<br />Engineer custom solutions tailored to workflows.<br />Address unique business challenges effectively.<br />Overcome limitations of off-the-shelf software.</p>
              </div>
            </li>
            
            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={mobile} alt="Mobile App Development" width="120" />
                </div>
                <h2 className="home-service-card-title">Mobile App Development</h2>
              </div>
              <div className="home-service-card-content">
                <p>Increase engagement with intuitive apps.<br />Develop native and cross-platform solutions.<br />Connect with audience anytime, anywhere.<br />Open new revenue channels effectively.</p>
              </div>
            </li>
            
            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={website} alt="Website Development" width="120" />
                </div>
                <h2 className="home-service-card-title">Website <br/> Development</h2>
              </div>
              <div className="home-service-card-content">
                <p>Craft bespoke, responsive websites.<br />Engineer high-performance digital presence.<br />Cornerstone for business assets.<br />Optimized for results and user experience.</p>
              </div>
            </li>
            
            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={ecommerce} alt="E-Commerce Development" width="120" />
                </div>
                <h2 className="home-service-card-title">E-Commerce Development</h2>
              </div>
              <div className="home-service-card-content">
                <p>Optimize customer journey for value.<br />Build seamless, secure platforms.<br />Create scalable online stores.<br />Generate revenue through powerhouses.</p>
              </div>
            </li>
            
            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={digital} alt="Digital Marketing" width="120" />
                </div>
                <h2 className="home-service-card-title">Digital Marketing</h2>
              </div>
              <div className="home-service-card-content">
                <p>Data-driven campaigns for growth.<br />Resonate with ideal audience.<br />Beyond generic ads and clicks.<br />Quantifiable results in marketing.</p>
              </div>
            </li>
            
            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={branding} alt="Branding Strategy" width="120" />
                </div>
                <h2 className="home-service-card-title">Branding Strategy</h2>
              </div>
              <div className="home-service-card-content">
                <p>Differentiate offers in market.<br />Build powerful brand identity.<br />More than just a logo.<br />Command market with promise.</p>
              </div>
            </li>
            
            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={threeDAni} alt="3D Animations" width="120" />
                </div>
                <h2 className="home-service-card-title">3D Animations</h2>
              </div>
              <div className="home-service-card-content">
                <p>Accelerate understanding with visuals.<br />Drive sales through immersion.<br />Capture attention with storytelling.<br />Explain complex in 3D.</p>
              </div>
            </li>

            <li className="home-service-card-item">
              <div className="home-service-card-overlay"></div>
              <div className="home-service-card-frame">
                <div className="home-service-card-picture">
                  <img src={educon} alt="Educational Consultancy" width="120" />
                </div>
                <h2 className="home-service-card-title">Educational Consultancy</h2>
              </div>
              <div className="home-service-card-content">
                <p>Provide expert guidance for education.<br />Tailor strategies for institutions.<br />Enhance learning outcomes effectively.<br />Support academic excellence initiatives.</p>
              </div>
            </li>
          </ul>
        </div>
      </section>

      {/* Technologies Section */}
<section id="home-technologies-section" className="home-technologies-section">
 <SpaceBackground />
<div class="stars"></div>
<div class="shooting-star"></div>
<div class="shooting-star"></div>
<div class="shooting-star"></div>
<div class="shooting-star"></div>
<div class="shooting-star"></div>
  <div className="home-tech-overlay"></div>
  
  <div className="home-tech-content text-center">
    <h2 className="home-tech-title">Our Technologies</h2>
    <div className="home-tech-underline"></div>
    <div className="home-tech-grid">
      <div className="home-tech-card"><img src="/images/react.webp" alt="React" /></div>
      <div className="home-tech-card"><img src="/images/html5.webp" alt="HTML5" /></div>
      <div className="home-tech-card"><img src="/images/javascript.webp" alt="JavaScript" /></div>
      <div className="home-tech-card"><img src="/images/php.webp" alt="PHP" /></div>
      <div className="home-tech-card"><img src="/images/angular.webp" alt="AngularJS" /></div>
      <div className="home-tech-card"><img src="/images/android.webp" alt="Android" /></div>
      <div className="home-tech-card"><img src="/images/css3.webp" alt="CSS3" /></div>
      <div className="home-tech-card"><img src="/images/dotnet.webp" alt=".NET" /></div>
    </div>
    <Link to="/about#technologies" className="home-view-btn">View More</Link>
    <p className="home-tech-description">
      Oakya IT Services Technologies is a leading provider of innovative digital solutions, 
      committed to transforming businesses through technology.
    </p>
  </div>
</section>

      {/* Industries Section */}
      <section id="home-industries-section" className="home-why-choose-us">
        <h2 className="home-section-title">Why Choose Us?</h2>
        <h2 className="home-industries-title">We Serve a Wide Variety of Industries</h2>
        <div className="home-section-underline"></div>
        
        <div className="home-why-choose-slider">
          {fullSlides.map((slide, index) => (
            <div
              key={index}
              className="home-why-choose-item"
              ref={(el) => (itemsRef.current[index] = el)}
            >
              <h3>{slide.title}</h3>
              <p>{slide.text}</p>
            </div>
          ))}

          <button
            className="home-why-choose-nav home-why-choose-prev"
            onClick={() => {
              setAutoPlay(false);
              prevSlide();
            }}
          >
            {"❮"}
          </button>
          <button
            className="home-why-choose-nav home-why-choose-next"
            onClick={() => {
              setAutoPlay(false);
              nextSlide();
            }}
          >
            {"❯"}
          </button>
        </div>
      </section>


      {/* Process Section */}
      <section id="home-process">
        <div className="home-process-overlay"></div>
        <div className="home-process-content">
          <div className="home-stars-process"></div>
          <h2>Our Process</h2>
          <div className="home-process-underline"></div>
          <div ref={containerRef} className="home-process-container">
            {orderedSteps.map((step, index) => (
              <div 
                key={step.id} 
                id={`home-${step.id}`}
                ref={el => cardRefs.current[index] = el}
                className="home-process-card"
              >
                <img src={step.image} alt={step.title} />
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}

            <svg 
              ref={svgRef}
              className="home-connect-lines" 
              width="100%" 
              height="100%" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <defs>
                <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                  <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
                  <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -8" result="glow" />
                  <feComposite in="SourceGraphic" in2="glow" operator="over" />
                </filter>
                <linearGradient id="pulse-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#00ffff" stopOpacity="0" />
                  <stop offset="50%" stopColor="#00ffff" stopOpacity="1" />
                  <stop offset="100%" stopColor="#00ffff" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </section>
<section className="home-unique-testimonials">
  <div className="c-container">
    <div className="client-section-title">
      <h2>What Clients Say</h2>
      <div className="separator"></div>
    </div>
    <Slider
  dots={true}
  infinite={true}
  speed={500}
  slidesToShow={isMobile ? 1 : 2}
  slidesToScroll={1}
  arrows={false}
  autoplay={true}
  autoplaySpeed={3000}
      responsive={[
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]}
    >
{/* Testimonial 1 - 5 FULL STARS */}
<div className="home-testimonial-block">
  <div className="home-inner-box">
    <div className="home-image">
      <img src={client1} alt="Dr. Nagendra Babu" />
    </div>
    <div className="home-content">
      <i className="fas fa-quote-right"></i>
      
      <div className="home-text">Oakya IT Services transformed our hospital’s digital presence with a strategy that aligns perfectly with our holistic values. Their expertise boosted our online visibility and helped us connect with a new generation seeking natural healthcare. Highly recommended!</div>
      <div className="home-home-author-info">Dr. Nagendra Babu <span>/ Chief Physician</span></div>
    </div>
  </div>
</div>
      {/* Testimonial 2 - 5 FULL STARS */}
      <div className="home-testimonial-block">
        <div className="home-inner-box">
          <div className="home-image">
            <img src={client2} alt="BCT" />
          </div>
          <div className="home-content">
            <i className="fas fa-quote-right"></i>
            
            <div className="home-text">Oakya IT Services truly understands our vision and acts as a proactive partner. Their tailored content and lead generation strategies have boosted our visibility and attracted qualified clients. We highly recommend their reliable, strategic approach.</div>
            <div className="home-author-info">BCT <span>/ Team BCT</span></div>
          </div>
        </div>
      </div>

      {/* Testimonial 3 - 5 FULL STARS */}
      <div className="home-testimonial-block">
        <div className="home-inner-box">
          <div className="home-image">
            <img src={client3} alt="M.vekata chowdary" />
          </div>
          <div className="home-content">
            <i className="fas fa-quote-right"></i>
            
            <div className="home-text">As the owner of Rayudu Gari Military Hotel, partnering with Oakya IT Services was a game-changer. They delivered a complete digital solution, capturing our brand’s unique heritage and boosting our online presence. Highly recommended for any business seeking digital transformation.</div>
            <div className="home-author-info">M.vekata chowdary <span>/ Restaurant Founder</span></div>
          </div>
        </div>
      </div>

      {/* Testimonial 4 - 5 FULL STARS */}
      <div className="home-testimonial-block">
        <div className="home-inner-box">
          <div className="home-image">
            <img src={client4} alt="Jagadeesh Garlapati" />
          </div>
          <div className="home-content">
            <i className="fas fa-quote-right"></i>
            
            <div className="home-text">Oakya IT Services played a vital role in Asian Crop Care’s growth by enhancing our online presence through expert digital marketing and web design. Their professional team helped us effectively reach farmers and distributors. Highly recommended!</div>
            <div className="home-author-info">Jagadeesh Garlapati <span>/ Business Owner</span></div>
          </div>
        </div>
      </div>

      <div className="home-testimonial-block">
        <div className="home-inner-box">
          <div className="home-image">
            <img src={client5} alt="jyothi polytechnique" />
          </div>
          <div className="home-content">
            <i className="fas fa-quote-right"></i>
            
            <div className="home-text">Oakya IT Services created a modern, dynamic website for Sri Jyothi Polytechnic College that perfectly meets our needs. Their professional team delivered excellent service, significantly enhancing our online presence. We’re very satisfied with the results.</div>
            <div className="home-author-info">Jyothi polytechnique College <span>/ College</span></div>
          </div>
        </div>
      </div>
    </Slider>
  </div>
</section>
    </div>
  );
};

export default Home;